interface PageProps {
  productId: string
  version: string
  locale: string
  pageId: string
}

/**
 * Generates a page path based on provided parameters.
 *
 * @param props Object containing productId, version, locale, and pageId.
 * @returns The generated page path.
 * @throws Throws an error if any of the parameters are invalid (not a string or empty).
 */
export default function createPagePath({
  productId,
  version,
  locale,
  pageId,
}: PageProps) {
  const isInvalid = [productId, version, locale, pageId].some(
    (param) => typeof param !== 'string' || param.length <= 0
  )
  if (isInvalid) {
    throw new Error('One or more invalid parameters provided')
  }
  return `/${productId}/${version}/${locale}/${pageId}`
}
